<template>
	<div class="step-wrapper">
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step9.message1')"/>
		<!-- Phone Numbers -->
		<div class="info-blocks">
			<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step9.message2')"/>
			<text-block-generic :params="paramsPhoneOne" :mask="PHONE_NUMBER_WITH_3_INDICATIVE"/>
			<text-block-generic :params="paramsPhoneTwo" :mask="PHONE_NUMBER_WITH_3_INDICATIVE"/>
			<text-block-generic :params="paramsPhoneThree" :mask="PHONE_NUMBER_WITH_3_INDICATIVE"/>
		</div>
		<!-- Email -->
		<div class="info-blocks">
			<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step9.emailLabel')"/>
			<text-block-generic :params="paramsEmail"/>
		</div>
		<!-- Sms -->
		<div class="info-blocks">
			<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step9.smsLabel')"/>
			<text-block-generic :params="paramsWeb"/>
		</div>
	</div>
</template>

<script setup>
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue */
import { ref } from 'vue'
import { PHONE_NUMBER_WITH_3_INDICATIVE } from '@/assets/constants/masks'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const paramsPhoneOne = ref({
	content: t('payments.batchfile.newPayment.helperModal.step9.phoneNumber1')
})

const paramsPhoneTwo = ref({
	content: t('payments.batchfile.newPayment.helperModal.step9.phoneNumber2')
})

const paramsPhoneThree = ref({
	content: t('payments.batchfile.newPayment.helperModal.step9.phoneNumber3')
})

const paramsEmail = ref({
	content: 'atendimentobancaelectronica@bancobai.ao'
})
const paramsWeb = ref({
	content: 4224
})
</script>

<style lang="scss" scoped>
.step-wrapper {
	width: 100%;
	padding-bottom: 56px;

	display: flex;
	flex-direction: column;

	gap: 24px;
	color: var(--secondary-dark-2);
	.step-message {
		@include H7-Regular;
        line-height: 16px;
		word-wrap: break-word;
	}

	.info-blocks {
		display: flex;
		flex-direction: column;

		.step-message {
			@include H7-Medium;
			line-height: 16px;
			word-wrap: break-word;
		}
	}
}
</style>
